var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSasg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10,
    fill: "url(#paint1_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3361 15L38.9236 35.0702H32.5162L27.3361 26.0981L21.6113 36.014H22.7011L19.4974 41.5631H12L27.3361 15ZM16.2936 49L27.8811 28.9298L31.0849 34.4787L25.9049 43.4509H37.3546L36.8097 42.5071L43.2172 42.507L46.9659 49H16.2936ZM32.1746 21.4931L35.9235 15.0001L51.2597 41.5632H28.0845L31.2885 36.0143L41.6484 36.0141L35.9235 26.0982L35.3786 27.042L32.1746 21.4931Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -1.25416e-7,
    y1: 42.6669,
    x2: 64.0085,
    y2: 42.6159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7954"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSasg);
export default __webpack_public_path__ + "static/media/sasg.c6d9fa3e.svg";
export { ForwardRef as ReactComponent };